// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/sysSetting',
    name: 'SysSetting',
    component: layout,
    redirect: '/sysSetting/device',
    meta: {
      title: '系统管理',
      icon: 'i-tabler:settings',
      roles: [0]
    },
    sort: 9,
    children: [
      {
        path: 'device',
        name: 'SysDevice',
        component: () => import('@/views/Manage/Device.vue'),
        meta: {
          title: '设备列表',
          icon: 'i-tabler:device-desktop',
          roles: [0]
        }
      },
      {
        path: 'model',
        name: 'SysModelManage',
        component: () => import('@/views/Manage/Model.vue'),
        meta: {
          title: '模型列表',
          icon: 'i-tabler:brand-adobe-illustrator',
          roles: [0]
        }
      },
      {
        path: 'model-demo',
        name: 'SysModelDemo',
        component: () => import('@/views/Manage/ModelDemo.vue'),
        meta: {
          title: '模型列表-demo',
          icon: 'i-tabler:brand-adobe-illustrator',
          roles: [0]
        }
      },

      {
        path: 'brand',
        name: 'SysBrand',
        component: () => import('@/views/Manage/Brand.vue'),
        meta: {
          title: '品牌列表',
          icon: 'i-tabler:brand-abstract',
          roles: [0]
        }
      },
      {
        path: 'supplier',
        name: 'SysSupplier',
        component: () => import('@/views/Manage/Supplier/Index.vue'),
        meta: {
          title: '供应商管理',
          icon: 'i-tabler:truck-delivery',
          roles: [0]
        }
      },
      {
        path: 'supplier/config',
        name: 'SysSupplierConfig',
        component: () => import('@/views/Manage/Supplier/PriorityConfig.vue'),
        meta: {
          title: '供应商优先级配置',
          icon: 'i-tabler:adjustments-horizontal',
          roles: [0]
        }
      }
    ]
  }
]
export default routes
